import { TranslationSet } from './en';

// TODO: translate values from English
export const ru: TranslationSet = {
  '(From Now)': '(С этого момента)',
  '(From Scheduled)': '(Из расписания)',
  '{amount} Off. Expires: {expires}.': '{amount} Выкл. Срок действия истекает: {expires}.',
  'A detailed report showing each activity and how long a technician or staff member took between and at each site with a total time at the site.': 'Подробный отчет, показывающий каждое действие и время, проведенное техническим специалистом или сотрудником между объектами и на каждом объекте, а также общее время на объекте.',
  'A service type with inspection enabled will show up in the "to inspect" list on mobile. It is also used in reporting.': 'Тип услуги с включенной проверкой будет отображаться в списке «для проверки» на мобильном устройстве. Он также используется в отчетности.',
  'Accept Invite': 'Принять приглашение',
  'Add Condition': 'Добавить условие',
  'Add deficiencies to the equipment type': 'Добавить недостатки к типу оборудования',
  'Add Deficiency': 'Добавить дефицит',
  'Add Equipment Field': 'Добавить поле оборудования',
  'Add Equipment Type': 'Добавить тип оборудования',
  'Add Equipment': 'Добавить оборудование',
  'Add Floor Plan': 'Добавить пла�� этажа',
  'Add history by clicking the plus in the top right or by performing a service.': 'Добавьте историю, нажав плюс в правом верхнем углу или выполнив услугу.',
  'Add History': 'Добавить историю',
  'Add Model Field': 'Добавить поле модели',
  'Add Model': 'Добавить модель',
  'Add Option': 'Добавить вариант',
  'Add Question': 'Добавить вопрос',
  'Add questions using the plus icon in the top right': 'Добавляйте вопросы, используя значок плюса в правом верхнем углу.',
  'Add service month categories in settings > service month categories. Service months allow you to keep different types of equipment in selected months for each location. Example: Alarms in May and October and Extinguishers in December.': 'Добавьте категории месяцев обслуживания в настройках > Категории месяцев обслуживания. Месяцы обслуживания позволяют вам хранить различные типы оборудования в выбранные месяцы для каждого местоположения. Пример: сигналы тревоги в мае и октябре и огнетушители в декабре.',
  'Add Service Month Category': 'Добавить категорию месяца обслуживания',
  'Add Service Type': 'Добавить тип услуги',
  'Add service types in the settings': 'Добавьте типы услуг в настройках',
  'Add service types using the plus icon in the top right': 'Добавьте типы услуг, используя значок плюса в правом верхнем углу.',
  'Add services to the equipment type': 'Добавить услуги к типу оборудования',
  'Add site Field': 'Добавить поле сайта',
  'Add Site Override': 'Добавить переопределение сайта',
  'Add Site Type': 'Добавить тип сайта',
  'Add Site': 'Добавить сайт',
  'Add Sites': 'Добавить сайты',
  'Add User': 'Добавить пользователя',
  'Add your own fields in Settings > Custom Fields > Site Fields': 'Добавьте свои собственные поля в «Настройки» > «Настраиваемые поля» > «Поля сайта».',
  'Add': 'Добавить',
  'Adding': 'Добавление',
  'Address': 'Адрес',
  'Advance from Now': 'Продвижение с настоящего момента',
  'Advance from Scheduled': 'Продвижение от запланированного',
  'Agree': 'Согласен',
  'All Sites Scheduled!': 'Все сайты запланированы!',
  'All': 'Все',
  'Already have an account? Login': 'У вас уже есть аккаунт? Войти',
  'An error happened while syncing': 'Произошла ошибка при синхронизации',
  'April': 'апрель',
  'August': 'август',
  'Back': 'Назад',
  'Billing Portal': 'Биллинговый портал',
  'Building Reports': 'Отчеты о строительстве',
  'Cancel Plan': 'Отменить план',
  'Cancel Subscription': 'Отменить подписку',
  'Cancel': 'Отмена',
  'Change Model Fields': 'Изменить поля модели',
  'Change Password': 'Изменить пароль',
  'Checklist Information': 'Информация о контрольном списке',
  'Checklist Question': 'Контрольный список вопросов',
  'Checklist': 'Контрольный список',
  'Choose File': 'Выберите файл',
  'City': 'Город',
  'Clear All Data': 'Очистить все данные',
  'Clear': 'Очистить',
  'Click or tap to add location': 'Нажмите или коснитесь, чтобы добавить местоположение',
  'Close': 'Закрыть',
  'Company-Wide Reports': 'Общекорпоративные отчеты',
  'Conditions': 'Условия',
  'Contact': 'Контакт',
  'Copy Barcode': 'Копировать штрих-код',
  'Could not access': 'Не удалось получить доступ',
  'Could not find equipment with the scanned barcode': 'Не удалось найти оборудование со отсканированным штрих-кодом.',
  'Could Not Service': 'Не удалось обслужить',
  'Create': 'Создать',
  'Creating Your Account': 'Создание вашей учетной записи',
  'Credentials are not valid': 'Учетные данные недействительны',
  'CSV': 'CSV-файл',
  'Custom Equipment Fields': 'Поля специального оборудования',
  'Custom Fields': 'Пользовательские поля',
  'Custom Model Fields': 'Пользовательские поля модели',
  'Custom site Fields': 'Пользовательские поля сайта',
  'Date': 'Дата',
  'Debug': 'Отладка',
  'December': 'декабрь',
  'Deficiencies': 'Недостатки',
  'Deficiency Report': 'Отчет о дефектах',
  'Deficiency': 'Дефицит',
  'Delete Equipment Field?': 'Удалить поле «Оборудование»?',
  'Delete Equipment Type?': 'Удалить тип оборудования?',
  'Delete Equipment Type': 'Удалить тип оборудования',
  'Delete Equipment?': 'Удалить оборудование?',
  'Delete Equipment': 'Удалить оборудование',
  'Delete Floor Plan?': 'Удалить план этажа?',
  'Delete Model Field?': 'Удалить поле модели?',
  'Delete Model?': 'Удалить модель?',
  'Delete Model': 'Удалить модель',
  'Delete Override': 'Удалить переопределение',
  'Delete Question?': 'Удалить вопрос?',
  'Delete Question': 'Удалить вопрос',
  'Delete Record?': 'Удалить запись?',
  'Delete Service Month?': 'Удалить месяц обслуживания?',
  'Delete Service Type?': 'Удалить тип услуги?',
  'Delete Site Field?': 'Удалить поле сайта?',
  'Delete Site Type?': 'Удалить тип сайта?',
  'Delete Site?': 'Удалить сайт?',
  'Delete Site': 'Удалить сайт',
  'Delete User?': 'Удалить пользователя?',
  'Delete User': 'Удалить пользователя',
  'Delete': 'Удалить',
  'Deleted Equipment Field': 'Поле удаленного оборудования',
  'Deleted Equipment': 'Удаленное оборудование',
  'Deleted Floor Plan': 'План этажа удален.',
  'Deleted Model Field': 'Удалено поле модели',
  'Deleted Record': 'Удаленная запись',
  'Deleted Service Month': 'Удален месяц обслуживания',
  'Deleted Service Type': 'Удаленный тип услуги',
  'Deleted Site Field': 'Удалено поле сайта',
  'Deleted Site Type': 'Удаленный тип сайта',
  'Detailed': 'Подробный',
  'Did not want done': 'Не хотел делать',
  'Done by others': 'Сделано другими',
  'Don\'t have an account? Sign Up': 'У вас нет учетной записи? Зарегистрироваться',
  'Done': 'Готово',
  'Edit Dates': 'Редактировать даты',
  'Edit Equipment': 'Редактировать оборудование',
  'Edit': 'Редактировать',
  'Email is not valid': 'Электронная почта недействительна',
  'End Date': 'Дата окончания',
  'Enter your email address': 'Введите свой адрес электронной почты',
  'Equipment already has this barcode': 'Оборудование уже имеет этот штрих-код',
  'Equipment can be anything from a fire extinguisher to a treadmill. Set up equipment types in settings > equipment types.': 'Оборудование может быть любым: от огнетушителя до беговой дорожки. Настройте типы оборудования в настройках > типы оборудования.',
  'Equipment Deleted': 'Оборудование удалено',
  'Equipment Due Consolidated Report': 'Консолидированный отчет о сдаче оборудования',
  'Equipment Due Report': 'Отчет о сдаче оборудования',
  'Equipment Field Information': 'Информация об оборудовании',
  'Equipment fields allow you to add different additional fields on the equipment type, such as "Voltage" or "Km".': 'Поля «Оборудование» позволяют добавлять различные дополнительные поля по типу оборудования, например «Напряжение» или «Км».',
  'Equipment Fields': 'Поля оборудования',
  'Equipment for a site with all scheduled services.': 'Оборудование объекта со всеми плановыми услугами.',
  'Equipment Options': 'Варианты оборудования',
  'Equipment Report': 'Отчет об оборудовании',
  'Equipment Service Report': 'Отчет об обслуживании оборудования',
  'Equipment SKU': 'Артикул оборудования',
  'Equipment Type Deleted': 'Тип оборудования удален',
  'Equipment Type': 'Тип оборудования',
  'Equipment types quickly add inspection and service definitions to equipment when a model containing it is selected. Examples: Fire Extinguisher, Treadmill, Truck': 'Типы оборудования быстро добавляют к оборудованию определения проверок и обслуживания при выборе модели, содержащей это оборудование. Примеры: огнетушитель, беговая дорожка, грузовик.',
  'Equipment Types': 'Типы оборудования',
  'Equipment': 'Оборудование',
  'Export Billing Data': 'Экспортировать платежные данные',
  'Export Data': 'Экспортировать данные',
  'Export': 'Экспорт',
  'Failed to load organization.': 'Не удалось загрузить организацию.',
  'Failed to save the organization.': 'Не удалось сохранить организацию.',
  'February': 'февраль',
  'Fill out the options below to prepare your report.': 'Заполните поля ниже, чтобы подготовить отчет.',
  'Filter By': 'Фильтровать по',
  'FlameTask Basic Subscription': 'Базовая подписка FlameTask',
  'FlameTask Enterprise Subscription': 'Корпоративная подписка FlameTask',
  'FlameTask Pro Subscription': 'Подписка FlameTask Pro',
  'Floor Plan Location': 'План этажа Расположение',
  'Floor Plan': 'План этажа',
  'Floor Plans': 'Планы этажей',
  'Force Error': 'Принудительная ошибка',
  'Forgot Password': 'Забыли пароль',
  'Generate': 'Генерировать',
  'Hide "added" history records': 'Скрыть «добавленные» записи истории',
  'Hide Advanced': 'Скрыть расширенные',
  'History': 'История',
  'How long a user spent at a site with time between actions.': 'Сколько времени пользователь провел на сайте с учетом времени между действиями.',
  'If this email matched an account, a link was sent to reset your password.': 'Если это письмо соответствует учетной записи, вам будет отправлена ссылка для сброса пароля.',
  'Import Data': 'Импортировать данные',
  'Import': 'Импорт',
  'Inspection Due': 'Срок проверки',
  'Inspection Report': 'Отчет об инспекции',
  'Inspection': 'Инспекция',
  'Inspections are up to date': 'Проверки актуальны',
  'January': 'январь',
  'July': 'июль',
  'June': 'июнь',
  'Leave': 'Уйти',
  'List of all equipment at the site with options to show services and filtering based on due service and/or inspection.': 'Список всего оборудования на объекте с возможностью отображения услуг и фильтрацией на основе надлежащего обслуживания и/или проверки.',
  'List of all sites with their information. Options to filter by status and service month to find which sites are serviced in a specific month.': 'Список всех сайтов с их информацией. Параметры фильтрации по статусу и месяцу обслуживания, чтобы узнать, какие сайты обслуживаются в определенном месяце.',
  'List of equipment and deficiencies at the site, filtered by equipment with deficiencies that have a date opened and no closed date.': 'Список оборудования и недостатков на сайте, отфильтрованный по оборудованию с недостатками, имеющему открытую дату и не имеющую дату закрытия.',
  'List of equipment between a range of dates with answers to the questions asked when performing a service or inspection.': 'Список оборудования за определенный период с ответами на вопросы, задаваемые при проведении обслуживания или проверки.',
  'List of Equipment for a site with important information such as last inspection date and next due service, highlighting equipment due for inspection in red.': 'Список оборудования для объекта с важной информацией, такой как дата последней проверки и ближайшего обслуж��вания, с выделением оборудования, подлежащего проверке, красным цветом.',
  'List of equipment that fits model search criteria. Example: a list of 5 pieces of equipment with model information matching 6LB ABC DRY.': 'Список оборудования, подходящего под критерии поиска модели. Пример: список из 5 единиц оборудования с информацией о модели, соответствующей 6LB ABC DRY.',
  'Loading Equipment': 'Погрузочное оборудование',
  'Loading Models...': 'Загрузка моделей...',
  'Loading Scheduled Services...': 'Загрузка запланированных служб...',
  'Loading Scheduled Sites': 'Загрузка запланированных сайтов',
  'Loading Service Types...': 'Загрузка типов услуг...',
  'Loading Sites': 'Загрузка сайтов',
  'Loading Unscheduled Services...': 'Загрузка незапланированных услуг...',
  'Loading...': 'Загрузка...',
  'Location': 'Расположение',
  'Logging in...': 'Вход в систему...',
  'Login Failed': 'Ошибка входа',
  'Login': 'Войти',
  'Logout': 'Выход из системы',
  'March': 'март',
  'May': 'май',
  'Meter Based Condition': 'Состояние на основе счетчика',
  'Model Deleted': 'Модель удалена',
  'Model Field Information': 'Информация о поле модели',
  'Model fields allow you to describe and report on equipment such as "Size", "Type" and "Category".': 'Поля модели позволяют описывать и сообщать об оборудовании, например «Размер», «Тип» и «Категория».',
  'Model Fields': 'Поля модели',
  'Model Information': 'Информация о модели',
  'Model Name': 'Название модели',
  'Models allow quickly adding information to equipment such as which equipment type/services belong to it.': 'Модели позволяют быстро добавлять к оборудованию информацию, например, какой тип ��борудования/услуги ему принадлежат.',
  'Models': 'Модели',
  'Months of History (to start of month)': 'Месяцы истории (до начала месяца)',
  'More Details': 'Подробнее',
  'Name': 'Имя',
  'Nevermind': 'Неважно',
  'No Custom Equipment Fields': 'Нет полей для специального оборудования',
  'No Deficiencies': 'Нет недостатков',
  'No Equipment Fields': 'Нет полей оборудования',
  'No Equipment Types': 'Нет типов оборудования',
  'No Equipment': 'Без оборудования',
  'No Floor Plans': 'Нет планов этажей',
  'No History': 'Нет истории',
  'No Model Fields': 'Нет полей модели',
  'No Models': 'Нет моделей',
  'No Open Deficiencies': 'Нет открытых недостатков',
  'No Open or Closed Issues': 'Нет открытых или закрытых вопросов',
  'No overrides for this Site': 'Для этого сайта нет переопределений',
  'No Questions': 'Нет вопросов',
  'No Scheduled Services': 'Нет плановых услуг',
  'No Scheduled Sites': 'Нет запланированных сайтов',
  'No Service Month Categories': 'Нет категорий месяцев обслуживания',
  'No Service Types': 'Нет типов услуг',
  'No Site Fields': 'Нет полей сайта',
  'No Site Types': 'Нет типов сайтов',
  'No Sites': 'Нет сайтов',
  'No Unscheduled Services': 'Никаких внеплановых услуг',
  'No, Go Back': 'Нет, вернись',
  'No': 'Нет',
  'Not in at the time of inspection': 'Отсутствует на момент проверки',
  'Nothing to Inspect': 'Нечего проверять',
  'Nothing to Service': 'Нечего обслуживать',
  'November': 'ноябрь',
  'October': 'Октябрь',
  'Ok': 'ок',
  'Open a deficiency by clicking the plus in the top right of the pane. When the issue has been resolved, click on it and set the closed date.': 'Откройте дефицит, щелкнув плюс в правом верхнем углу панели. Когда проблема будет решена, нажмите на нее и установите дату закрытия.',
  'Open a deficiency by tapping Options > Add Deficiency': 'Откройте дефицит, нажав «Параметры» > «Добавить дефицит».',
  'Open Deficiencies': 'Открытые недостатки',
  'Open Deficiency': 'Открытый дефицит',
  'Open in Apple Maps': 'Открыть в Apple Maps',
  'Open in Google Maps': 'Открыть в Google Картах',
  'Open Settings': 'Открыть настройки',
  'Open': 'Открыть',
  'Optional: Add a deficiency if this option is selected.': 'Необязательно: добавьте дефицит, если выбран этот параметр.',
  'Optional: This can be useful to set meter values easily': 'Необязательно: это может быть полезно для простой установки значений счетчика.',
  'Organization': 'Организация',
  'Outstanding Equipment': 'Выдающееся оборудование',
  'PDF': 'PDF',
  'Perform From Now': 'Выполнить с этого момента',
  'Perform From Scheduled': 'Выполнить из расписания',
  'Perform Service From Scheduled': 'Выполнение обслуживания по расписанию',
  'Perform Service': 'Выполнить обс��уживание',
  'Perform': 'Выполнить',
  'Phone Number': 'Номер телефона',
  'Please fill out all fields': 'Пожалуйста, заполните все поля',
  'Please give a reason': 'Пожалуйста, укажите причину',
  'Please select country first': 'Пожалуйста, сначала выберите страну',
  'Popup Note': 'Всплывающая заметка',
  'Preferences': 'Предпочтения',
  'Preview Details': 'Подробности предварительного просмотра',
  'Profile': 'Профиль',
  'Purchase Barcodes': 'Купить штрих-коды',
  'Question Deleted': 'Вопрос удален',
  'Question Information': 'Информация о вопросе',
  'Questionnaire Report': 'Отчет по анкете',
  'Questions': 'Вопросы',
  'Range End': 'Конец диапазона',
  'Range Start': 'Начало диапазона',
  'Reactivate': 'Повторно активировать',
  'Remove': 'Удалить',
  'Replace Barcode': 'Заменить штрих-код',
  'Replace Equipment': 'Заменить оборудование',
  'Replaced equipment': 'Замененное оборудование',
  'Report Date': 'Дата отчета',
  'Reports': 'Отчеты',
  'Save time and minimize risk by plotting the location of equipment on a floor plan of this site': 'Экономьте время и минимизируйте риск, нанося расположение оборудования на план этажа этого объекта.',
  'Save': 'Сохранить',
  'Saving': 'Сохранение',
  'Scan barcode to make changes': 'Сканируйте штрих-код, чтобы внести изменения.',
  'Scan Barcode': 'Сканировать штрих-код',
  'Scan': 'Сканировать',
  'Schedule': 'Расписание',
  'Scheduled Event': 'Запланированное событие',
  'Scheduled service definitions can be added to the equipment type in settings > equipment types': 'Определения запланированных услуг можно добавить к типу оборудования в настройках > типы оборудования.',
  'Scheduled': 'Запланировано',
  'See More': 'Посмотреть больше',
  'Selecting an option will add a history record and remove it from the todo list': 'Выбор опции добавит запись истории и удалит ее из списка дел.',
  'Selective Equipment Report': 'Отчет о выборочном оборудовании',
  'September': 'сентябрь',
  'Service Due': 'Срок обслуживания',
  'Service month categories allow you to keep different types of equipment in different months. For example, you could inspect fire extinguishers in August and May and alarms in October.': 'Категории месяцев обслуживания позволяют хранить разные типы оборудования в разные месяцы. Например, вы можете проверять огнетушители в августе и мае, а сигнализацию — в октябре.',
  'Service Month Categories': 'Категории месяцев обслуживания',
  'Service Month Category': 'Категория месяца обслуживания',
  'Service Month': 'Месяц обслуживания',
  'Service months allow you to keep different types of equipment in selected months for each site. Example: Alarms in May and October and Extinguishers in December.': 'Месяцы обслуживания позволяют вам хранить разные типы оборудования в выбранные месяцы для каждого объекта. Пример: сигналы тревоги в мае и октябре и огнетушители в декабре.',
  'Service Months': 'Месяцы обслуживания',
  'Service overrides allow you to disable a service or change the frequency for a specific site': 'Переопределение службы позволяет отключить службу или изменить частоту для определенного сайта.',
  'Service Type Settings': 'Настройки типа услуги',
  'Service Type': 'Тип услуги',
  'Service Types': 'Типы услуг',
  'Service': 'Сервис',
  'Services are up to date': 'Услуги актуальны',
  'Services': 'Услуги',
  'Set answer to equipment field': 'Установить ответ на поле оборудования',
  'Settings': 'Настройки',
  'Show Advanced': 'Показать расширенные',
  'Show History Time': 'Показать время истории',
  'Show Inspections': 'Показать проверки',
  'Show Questions / Answers': 'Показать вопросы/ответы',
  'Show Services': 'Показать услуги',
  'Sign Up': 'Зарегистрироваться',
  'Simulate Scan': 'Имитировать сканирование',
  'Site Deleted': 'Сайт удален',
  'Site Field Information': 'Информация о полях сайта',
  'Site fields will allow you to enter additional information into the site, such as "Parking Location".': 'Поля сайта позволят вам ввести на сайт дополнительную информацию, например «Место парковки».',
  'Site Fields': 'Поля сайта',
  'Site Information': 'Информация о сайте',
  'Site Report': 'Отчет о сайте',
  'Site Reports': 'Отчеты сайта',
  'Site Service Override': 'Переопределение службы сайта',
  'Site Service Overrides': 'Переопределения службы сайта',
  'Site Service Settings': 'Настройки службы сайта',
  'Site Settings': 'Настройки сайта',
  'Site Type': 'Тип сайта',
  'Site types allow you to change service types based on the site. For example, only monthly customers would show the monthly inspection.': 'Типы сайтов позволяют изменять типы услуг в зависимости от сайта. Например, только ежемесячные клиенты будут показывать ежемесячную проверку.',
  'Site types allow you to have different service types at different types of sites. For example, you may have to do monthly inspections at one site and only an annual inspection at another.': 'Типы сайтов позволяют использовать разные типы услуг на разных типах сайтов. Например, вам, возможно, придется проводить ежемесячные проверки на одном объекте и только ежегодную проверку на другом.',
  'Site Types': 'Типы сайтов',
  'Sites can help you organize equipment into places such as "Office" or "Warehouse". If you run a servicing company, you can add your clients as sites. ': 'Сайты могут помочь вам распределить оборудование по таким местам, как «Офис» или «Склад». Если вы управляете обслуживающей компанией, вы можете добавлять своих клиентов в качестве сайтов. ',
  'Sites': 'Сайты',
  'Start Date': 'Дата начала',
  'Start Trial': 'Начать пробную версию',
  'Status': 'Статус',
  'Summary of services at a site separated by model information. Example 5 Monthly Inspections with model information 6LB DRY ABC.': 'Сводка услуг на сайте, разделенная информацией о модели. Пример 5. Ежемесячные проверки с информацией о модели 6LB DRY ABC.',
  'Swap Equipment': 'Обмен оборудования',
  'Swapped equipment': 'Заменено оборудование',
  'TEST': 'ТЕСТ',
  'The EMS plan is a discounted plan for non-profit or publicly funded emergency services.  Please choose another plan if you do not match this criteria': 'План EMS — это план со скидкой для некоммерческих или финансируемых государством медицинских услуг.  Пожалуйста, выберите другой план, если вы не соответствуете этим критериям.',
  'The popup note is used to remind you of important information regarding the location. It will appear when opening the location screen.': 'Всплывающая заметка используется для напоминания вам о важной информации о местоположении. Он появится при открытии экрана местоположения.',
  'There are no unscheduled sites with outstanding inspections, service or deficiencies.': 'Нет внеплановых объектов с невыполненными проверками, обслуживанием или недостатками.',
  'There is no equipment at this site with this search criteria and due inspections': 'На данном объекте нет оборудования с указанными критериями поиска и надлежащими проверками.',
  'There is no equipment at this site with this search criteria and due service': 'На сайте нет оборудования с указанными критериями поиска и соответствующим сервисом.',
  'This Month': 'В этом месяце',
  'Time at Site Detailed': 'Подробное время на месте',
  'Time at Site': 'Время на сайте',
  'Time Based Condition': 'Условие, основанное на времени',
  'Today': 'Сегодня',
  'Transfer Equipment': 'Перегрузочное оборудование',
  'Unscheduled service definitions can be added to the equipment type in settings > equipment types': 'Определения внеплановых услуг можно добавить к типу оборудования в настройках > типы оборудования.',
  'Unscheduled': 'Внеплановый',
  'Updated barcode': 'Обновлен штрих-код',
  'Used Equipment SKU': 'Артикул б/у оборудования',
  'Used for the billing export for new, swapped and replaced equipment.': 'Используется для экспорта счетов за новое, замененное и замененное оборудование.',
  'User Deleted': 'Пользователь удален',
  'User Information': 'Информация о пользователе',
  'User': 'Пользователь',
  'Users': 'Пользователи',
  'View on FloorPlan': 'Посмотреть на плане этажа',
  'View Terms': 'Посмотреть условия',
  'Whenever equipment is swapped the billing export will increment the quantitiy under this SKU.': 'При каждой замене оборудования при экспорте счетов количество по этому SKU будет увеличиваться.',
  'Yes, Delete Equipment Field': 'Да, удалить поле оборудования',
  'Yes, Delete Equipment Type': 'Да, удалить тип оборудования',
  'Yes, Delete Equipment': 'Да, удалить оборудование',
  'Yes, Delete Floor Plan': 'Да, удалить план этажа',
  'Yes, Delete Model Field': 'Да, удалить поле модели',
  'Yes, Delete Model': 'Да, удалить модель',
  'Yes, Delete Question': 'Да, удалить вопрос',
  'Yes, Delete Record': 'Да, удалить запись',
  'Yes, Delete Service Month': 'Да, удалить месяц обслуживания',
  'Yes, Delete Service Type': 'Да, удалить тип услуги',
  'Yes, Delete Site Field': 'Да, удалить поле сайта',
  'Yes, Delete Site Type': 'Да, удалить тип сайта',
  'Yes, Delete Site': 'Да, удалить сайт',
  'Yes, Delete User': 'Да, удалить пользователя',
  'Zone': 'Зона',
  'Customer': 'Клиент',
  'Site': 'Сайт',
  'All Sites': 'Все сайты',
  'Loading Customers': 'Загрузка клиентов',
  'No Customers': 'Нет клиентов',
  'Add Customer': 'Добавить клиента',
  'Customers are groups of sites with billing information.': 'Клиенты — это группы сайтов с платежной информацией.',
  'Customers': 'Клиенты',
  'Customer Information': 'Информация о клиенте',
  'Delete Customer': 'Удалить клиента',
  'Yes, Delete Customer': 'Да, удалить клиента',
  'Delete Customer?': 'Удалить клиента?',
  'Customer Deleted': 'Клиент удален',
  'Create Customer': 'Создать клиента',
  'Assign Existing Customer': 'Назначить существующего клиента',
  'Edit Customer': 'Редактировать клиента',
  'Enter a serial number': 'Введите серийный номер',
  'Remove Customer': 'Удалить клиента',
  'Find': 'Найти',
  'Sync Now': 'Синхронизировать сейчас',
  'Syncing...': 'Синхронизация...',
  'Find equipment by serial number': 'Найти оборудование по серийному номеру',
  'Last successful upload was {formattedDate}': 'Последняя успешная загрузка: {formattedDate}.',
  'Up to date as of {formattedDate}': 'Актуально на {formattedDate}',
  'Zones are used to group locations in the location report': 'Зоны используются для группировки местоположений в отчете о местоположении.',

  'Account Number': 'Номер счета',
  'Add Location Override': 'Добавить переопределение местоположения',
  'Add New Model': 'Добавить новую модель',
  'Add Site Field': 'Добавить поле сайта',
  'Address Line 2': 'Адресная строка 2',
  'Agree to': 'Согласен',
  'All conditions are true': 'Все условия верны',
  'All Permissions': 'Все разрешения',
  'Allow Text Input': 'Разрешить ввод текста',
  'An email with the reset password link below has been sent to': 'Письмо со ссылкой для сброса пароля ниже было отправлено на адрес',
  'An error ocurred while trying to show this page.': 'Произошла ошибка при попытке показать эту страницу.',
  'Any condition is true': 'Любое условие истинно',
  'Background Color': 'Цвет фона',
  'Billing and customer controls': 'Выставление счетов и контроль клиентов',
  'Building Reports - Safety Scan': 'Отчеты о строительстве — сканирование безопасности',
  'Change Another Service': 'Изменить другую услугу',
  'Choose Site': 'Выберите сайт',
  'click here': 'кликните сюда',
  'Closed Date': 'Дата закрытия',
  'Closed Deficiencies': 'Закрытые недостатки',
  'Company Information': 'Информация о компании',
  'Company Name': 'Название компании',
  'Completing Sign Up': 'Завершение регистрации',
  'Context ID': 'Идентификатор контекста',
  'Could not find equipment with that barcode': 'Не удалось найти оборудование с таким штрих-кодом.',
  'Creating invite link...': 'Создание ссылки для приглашения...',
  'Current equipment failed to load': 'Текущее оборудование не удалось загрузить.',
  'Data File': 'Файл данных',
  'Data Origin': 'Происхождение данных',
  'Date affected by': 'Дата, на которую влияет',
  'Date Completed': 'Дата завершения',
  'Date Started': 'Дата начала',
  'Delete equipment?': 'Удалить оборудование?',
  'Dev Environment': 'Среда разработки',
  'Disabled For': 'Отключено для',
  'Disabled For Location': 'Отключено из-за местоположения',
  'Do not change': 'Не менять',
  'Due When': 'Срок сдачи когда',
  'Edit Deficiencies': 'Редактировать недостатки',
  'Edit History': 'Редактировать историю',
  'Edit Location': 'Изменить местоположение',
  'Edit Schedule': 'Изменить расписание',
  'Edit Service': 'Редактировать сервис',
  'Edit Settings': 'Изменить настройки',
  'End Time': 'Конец Времени',
  'Equal to': 'Равно',
  'Equipment Field': 'Поле оборудования',
  'Equipment replaced': 'Заменено оборудование',
  'Equipment swapped': 'Оборудование заменено',
  'Example: Broken Handle': 'Пример: сломанная ручка',
  'Frequency Type': 'Тип частоты',
  'Generate Reports': 'Генерировать отчеты',
  'Get started by checking out our tutorials on YouTube or setting up your account in settings.': 'Начните с просмотра наших руководств на YouTube или настройте свою учетную запись в настройках.',
  'Global Search': 'Глобальный поиск',
  'Greater than': 'Больше, чем',
  'hasn&apos;t accepted their invite yet. You can': 'еще не принял приглашение. ',
  'Include In Reports': 'Включить в отчеты',
  'landscape LetterHead': 'пейзаж LetterHead',
  'Last Date': 'Последняя дата',
  'Last Date Minimum Granularity': 'Минимальная степень детализации последней даты',
  'Last Download': 'Последняя загрузка',
  'Last Upload': 'Последняя загрузка',
  'Less than': 'Меньше, чем',
  'Locations can only be added on a desktop browser': 'Местоположение можно добавлять только в браузере настольного компьютера.',
  'Looks like you never finished signing up': 'Похоже, вы так и не завершили регистрацию',
  'Metered Condition': 'Измеренное состояние',
  'Mobile Access': 'Мобильный доступ',
  'Model Number': 'Номер модели',
  'Next Date (Overide)': 'Следующая дата (переопределить)',
  'No Conditions': 'Нет условий',
  'No Options': 'Нет вариантов',
  'Not equal to': 'Не равно',
  'Opened Date': 'Дата открытия',
  'Option Selected': 'Выбранный вариант',
  'Perform On Scan': 'Выполнять при сканировании',
  'Please click the button below to start your free 3 month trial': 'Нажмите кнопку ниже, чтобы начать бесплатную 3-месячную пробную версию.',
  'Please review the terms below': 'Пожалуйста, ознакомьтесь с условиями ниже',
  'Portrait LetterHead': 'Портрет Буквы',
  'Postal Code': 'Почтовый индекс',
  'Powered By': 'Питаться от',
  'Preventive Maintenance': 'Профилактическое обслуживание',
  'Profile Image': 'Изображение профиля',
  'Receive marketing emails': 'Получайте маркетинговые электронные письма',
  'Rivison Inc.': 'Ривисон Инк.',
  'Search Sites...': 'Поиск по сайтам...',
  'Serial Number': 'Серийный номер',
  'Service is Unscheduled': 'Служба внеплановая',
  'Service Options': 'Варианты обслуживания',
  'Service or Inspection Due': 'Срок обслуживания или проверки',
  'Show All': 'Показать все',
  'Show site selector in top corner': 'Показывать выбор сайта в верхнем углу',
  'Sign-Up Failed. Ensure the email is not already is use.': 'Регистрация не удалась. ',
  'Sorry, an error occurred while trying to create an invite link. Please try again later, or reach out to support': 'К сожалению, при попытке создать ссылку для приглашения произошла ошибка. ',
  'Sorry, looks like you&apos;re offline. Please try again when you have an internet connection': 'Извините, похоже, вы не в сети. ',
  'Start Time': 'Время начала',
  'Successfully updated profile': 'Профиль успешно обновлен.',
  'terms and conditions': 'условия и положения',
  'Text Input': 'Ввод текста',
  'The date below is used to show history records only.': 'Дата ниже используется только для отображения записей истории.',
  'This will just take a moment': 'Это займет всего минуту',
  'Time Condition': 'Условия времени',
  'Time Zone': 'Часовой пояс',
  'to generate another invite link.': 'чтобы создать еще одну ссылку для приглашения.',
  'Toggle Flashlight': 'Переключить фонарик',
  'Type more characters to narrow the search further': 'Введите больше символов, чтобы еще больше сузить поиск.',
  'Use text answer for': 'Используйте текстовый ответ для',
  'Version:': 'Версия:',
  'View Deficiencies': 'Посмотреть недостатки',
  'View Equipment': 'Посмотреть оборудование',
  'View History': 'Просмотреть историю',
  'View Location': 'Посмотреть местоположение',
  'View Schedule': 'Посмотреть расписание',
  'View Service': 'Посмотреть услугу',
  'View Settings': 'Просмотр настроек',
  'We hope to see you again.': 'Мы надеемся увидеть вас снова.',
  'Web Login': 'Веб-вход',
  'Welcome,': 'Добро пожаловать,',
  'White Label': 'Белая этикетка',
  'Work Day End Time': 'Время окончания рабочего дня',
  'Work Day Start Time': 'Время начала рабочего дня',
  'You must agree to the terms and conditions': 'Вы должны согласиться с условиями',
  'Your Subscription Has Been Canceled': 'Ваша подписка отменена',
};
